<div class="setup-page-wrapper">
  <div class="business-dialog-container">
    <div class="dialog-header">
      <h3 class="dialog-title">
        {{
        type === "customer" ? "Business Customer Details" : "Vendor Details"
        }}
      </h3>
    </div>

    <div class="form-body">
      <p class="intro-text">
        Please provide the following details. This will update your profile.
      </p>

      <form #setupForm="ngForm" (ngSubmit)="submitForm(setupForm, $event)" class="form">
        <div class="form-row">
          <!-- Your Name -->
          <div class="half-width mb-12">
            <label class="input-label">Your Name <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="setupForm.submitted && !formData.firstname">
              <mat-icon class="prefix-icon">person_outline</mat-icon>
              <input type="text" [(ngModel)]="formData.firstname" name="firstname" placeholder="Ex: John Doe"
                required />
            </div>
            <div class="error-msg" *ngIf="setupForm.submitted && !formData.firstname">
              Name is required
            </div>
          </div>

          <!-- Company Legal Name -->
          <div class="half-width mb-12">
            <label class="input-label">Company Legal Name <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="
                setupForm.submitted && !formData.accountdetails.companyname
              ">
              <mat-icon class="prefix-icon">business</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.companyname" name="companyname"
                placeholder="Ex: Aluguloo LLC" required />
            </div>
            <div class="error-msg" *ngIf="
                setupForm.submitted && !formData.accountdetails.companyname
              ">
              Company name is required
            </div>
          </div>
        </div>

        <!-- Company Address -->
        <div class="full-width mb-12">
          <label class="input-label">Company Address <span class="required-star">*</span></label>
          <div class="custom-input-box" [class.error]="
              setupForm.submitted && !formData.accountdetails.companyAddress
            ">
            <mat-icon class="prefix-icon">location_on</mat-icon>
            <textarea [(ngModel)]="formData.accountdetails.companyAddress" name="companyAddress" rows="1"
              placeholder="Ex: Office 101, Business Bay, Dubai" required></textarea>
          </div>
          <div class="error-msg" *ngIf="
              setupForm.submitted && !formData.accountdetails.companyAddress
            ">
            Address is required
          </div>
        </div>

        <!-- Company Logo Upload -->
        <div class="company-logo-wrapper">
          <div class="logo-preview" [style.backgroundImage]="getLogoStyle()"></div>
          <input type="file" id="logoInput" (change)="onLogoSelected($event)" accept="image/*" hidden />
          <div class="logo-info">
            <p>Upload a clear PNG or JPG logo.</p>
            <div class="logo-actions" style="display: flex; gap: 10px; margin-top: 8px">
              <button mat-stroked-button type="button" color="primary" (click)="triggerFileInput()" class="logo-btn">
                <mat-icon>{{
                  formData.accountdetails.companyLogoUrl ? "edit" : "upload"
                  }}</mat-icon>
                {{
                formData.accountdetails.companyLogoUrl
                ? "Edit Logo"
                : "Upload Logo"
                }}
              </button>
            </div>
          </div>
        </div>

        <!-- Phone row -->
        <div class="phone-row mb-12">
          <!-- Business Phone -->
          <div class="half-width">
            <label class="input-label">Business Phone <span class="required-star">*</span></label>
            <div class="combined-phone-box" [class.error]="
                setupForm.submitted && !formData.accountdetails.phoneNumber
              ">
              <mat-select [(ngModel)]="formData.accountdetails.countryCode" name="countryCode"
                panelClass="wide-country-dropdown" disableOptionCentering class="country-mini-select">
                <mat-select-trigger>
                  <div class="flex-center" *ngIf="getSelectedCountry() as sel">
                    <img [src]="sel.flag" class="flag-icon-small" />
                    {{ sel.code }}
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let c of countryList" [value]="c.code">
                  <img [src]="c.flag" class="flag-icon" />
                  {{ c.name }} ({{ c.code }})
                </mat-option>
              </mat-select>
              <mat-icon class="prefix-icon">phone</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.phoneNumber" name="phoneNumber"
                [maxlength]="currentPhoneLimit" (keypress)="numberOnly($event)" placeholder="Phone number" required />
            </div>
            <div class="error-msg" *ngIf="
                setupForm.submitted && !formData.accountdetails.phoneNumber
              ">
              Phone is required
            </div>
          </div>

          <!-- Telephone -->
          <div class="half-width">
            <label class="input-label">Telephone</label>
            <div class="combined-phone-box">
              <mat-select [(ngModel)]="formData.accountdetails.telephoneCountryCode" name="telephoneCountryCode"
                panelClass="wide-country-dropdown" disableOptionCentering class="country-mini-select">
                <mat-select-trigger>
                  <div class="flex-center" *ngIf="getTelSelectedCountry() as sel">
                    <img [src]="sel.flag" class="flag-icon-small" />
                    {{ sel.code }}
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let c of countryList" [value]="c.code">
                  <img [src]="c.flag" class="flag-icon" />
                  {{ c.name }} ({{ c.code }})
                </mat-option>
              </mat-select>
              <mat-icon class="prefix-icon">phone_in_talk</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.telephone" name="telephone"
                [maxlength]="currentTelLimit" (keypress)="numberOnly($event)" placeholder="Telephone" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <!-- Business Email -->
          <div class="half-width mb-12">
            <label class="input-label">Business Email <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="
                setupForm.submitted && setupForm.controls['emailid'].invalid
              ">
              <mat-icon class="prefix-icon">mail_outline</mat-icon>
              <input type="email" [(ngModel)]="formData.accountdetails.emailid" name="emailid" required email
                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$" placeholder="Ex: business@example.com" />
            </div>
            <div class="error-msg" *ngIf="
                setupForm.submitted && setupForm.controls['emailid'].invalid
              ">
              A valid email is required
            </div>
          </div>

          <!-- Trade License No -->
          <div class="half-width mb-12">
            <label class="input-label">Trade License No. <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="
                setupForm.submitted && !formData.accountdetails.tradeLicenseNo
              ">
              <mat-icon class="prefix-icon">verified_user</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.tradeLicenseNo" name="tradeLicenseNo"
                placeholder="Ex: 123456" required />
            </div>
            <div class="error-msg" *ngIf="
                setupForm.submitted && !formData.accountdetails.tradeLicenseNo
              ">
              License number is required
            </div>
          </div>
        </div>

        <div class="form-row" style="margin-bottom: 4px">
          <!-- License Expiry Date -->
          <div class="half-width mb-12" style="position: relative">
            <label class="input-label">License Expiry Date <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="setupForm.submitted && !expiryDisplay" style="cursor: text">
              <mat-icon class="prefix-icon">calendar_today</mat-icon>
              <input type="text" [(ngModel)]="expiryDisplay" name="expiryDate" (input)="onExpiryInput($event)"
                (focus)="showExpiryCalendar = true" (click)="$event.stopPropagation()" placeholder="Ex: 31/12/2026"
                required />
              <mat-icon class="suffix-icon" (click)="openExpiryCalendar($event)"
                style="cursor: pointer">keyboard_arrow_down</mat-icon>
            </div>
            <div class="error-msg" *ngIf="setupForm.submitted && !expiryDisplay">
              Expiry date is required
            </div>

            <!-- Inline Calendar -->
            <div class="calendar-dropdown" *ngIf="showExpiryCalendar" (click)="$event.stopPropagation()">
              <div class="calendar-header">
                <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&#8249;</span>
                <div class="header-selectors">
                  <select [ngModel]="currentMonth" (ngModelChange)="selectMonth($event)" name="calMonth">
                    <option *ngFor="let m of monthNames; let i = index" [value]="i">
                      {{ m }}
                    </option>
                  </select>
                  <select [ngModel]="currentYear" (ngModelChange)="selectYear($event)" name="calYear">
                    <option *ngFor="let y of years" [value]="y">{{ y }}</option>
                  </select>
                </div>
                <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&#8250;</span>
              </div>
              <div class="calendar-weekdays">
                <span *ngFor="let d of weekdays">{{ d }}</span>
              </div>
              <div class="calendar-grid">
                <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                  [class.is-today]="day.isToday" [class.is-past]="day.isPast" [class.selected]="day.isSelected"
                  (click)="selectExpiryDay(day); $event.stopPropagation()">{{ day.date }}</span>
              </div>
            </div>
          </div>

          <!-- Issued By -->
          <div class="half-width mb-12">
            <label class="input-label">License Issued By <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="
                setupForm.submitted && !formData.accountdetails.issuedBy
              ">
              <mat-icon class="prefix-icon">account_balance</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.issuedBy" name="issuedBy" placeholder="Ex: DED"
                required />
            </div>
            <div class="error-msg" *ngIf="setupForm.submitted && !formData.accountdetails.issuedBy">
              Issued by is required
            </div>
          </div>
        </div>

        <!-- TRN Number row -->
        <div class="form-row" style="margin-bottom: 4px">
          <div class="half-width mb-12">
            <label class="input-label">TRN Number</label>
            <div class="custom-input-box">
              <mat-icon class="prefix-icon">receipt_long</mat-icon>
              <input type="text" [(ngModel)]="formData.accountdetails.trnNumber" name="trnNumber"
                placeholder="Ex: 100123456789003" maxlength="15" />
            </div>
          </div>
        </div>

        <!-- Trade License Upload -->
        <div class="upload-wrapper">
          <input type="file" id="licenseFileBusiness" (change)="onFileSelected($event)"
            accept=".pdf,.jpg,.jpeg,.png,.webp" class="file-input" />
          <label for="licenseFileBusiness" class="upload-btn">
            {{
            formData.accountdetails.companyDocuments?.length
            ? "Trade License Selected"
            : "Upload Trade License Copy"
            }}
            <small>PDF, JPG, JPEG, PNG, WEBP up to 10MB</small>
          </label>

          <!-- Document Previews -->
          <div class="preview-mini-card-container" *ngIf="formData.accountdetails.companyDocuments?.length">
            <div class="template-mini-card" *ngFor="
                let doc of formData.accountdetails.companyDocuments;
                let i = index
              ">
              <div class="mini-content" [class.uploading]="doc.uploading">
                <!-- Explicit Close Button -->
                <button mat-icon-button type="button" class="remove-btn-absolute" (click)="removeDocumentByIndex(i)"
                  matTooltip="Remove">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-progress-spinner *ngIf="doc.uploading" mode="indeterminate" diameter="30"
                  class="upload-spinner"></mat-progress-spinner>

                <!-- Image Preview -->
                <img *ngIf="isImage(doc.name) && !doc.uploading" [src]="doc.url" alt="Preview" class="preview-img" />

                <!-- PDF Preview -->
                <div *ngIf="
                    !isImage(doc.name) && !isDoc(doc.name) && !doc.uploading
                  " class="pdf-preview">
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span>PDF Document</span>
                </div>

                <!-- DOC Preview -->
                <div *ngIf="isDoc(doc.name) && !doc.uploading" class="pdf-preview">
                  <mat-icon>description</mat-icon>
                  <span>Document</span>
                </div>

                <!-- Action Buttons (Hover) -->
                <div class="card-actions" *ngIf="!doc.uploading">
                  <button type="button" mat-icon-button class="action-btn view-btn" matTooltip="View"
                    (click)="viewDocument(i)" *ngIf="isImage(doc.name)">
                  <mat-icon>visibility</mat-icon>
                  </button>
                  <a [href]="doc.url" target="_blank" mat-icon-button class="action-btn view-btn" matTooltip="View"
                    *ngIf="!isImage(doc.name)">
                    <mat-icon>visibility</mat-icon>
                  </a>
                </div>
              </div>
              <div class="template-name">{{ doc.name }}</div>
            </div>

            <!-- Add More Button -->
            <div class="add-more-wrapper">
              <input type="file" id="addMoreFiles" (change)="onFileSelected($event)"
                accept=".pdf,.jpg,.jpeg,.png,.webp" class="file-input" />
              <label for="addMoreFiles" class="add-more-btn" matTooltip="Add more documents">
                <mat-icon>add_circle</mat-icon>
                <span>Add more</span>
              </label>
            </div>
          </div>
        </div>

        <button class="primary-cta" type="submit" [disabled]="isSubmitting || !termsAccepted">
          {{
          type === "customer" ? "Save and Continue" : "Complete Registration"
          }}
        </button>
        <div class="terms-checkbox-wrapper" style="margin-bottom: 24px; text-align: center; margin-top: 10px">
          <mat-checkbox name="termsAccepted" [checked]="termsAccepted" (change)="onTermsCheckboxChange($event)"
            [class.error]="setupForm.submitted && !termsAccepted">
            I agree to the
            <a href="javascript:void(0)" (click)="openTermsDialog($event)"
              style="color: #57c4ef; text-decoration: underline">Terms and Conditions</a>
          </mat-checkbox>
          <div class="error-msg" *ngIf="setupForm.submitted && !termsAccepted"
            style="color: red; font-size: 12px; margin-top: 4px">
            You must accept the terms and conditions
          </div>
        </div>
        <p class="footer-text">All fields are mandatory.</p>
      </form>
    </div>
  </div>
</div>